module.exports = __webpack_public_path__ + "img/SUV.ca7f9818.svg";